export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    lang: 'zh'
  },
  mutations: {
    updateId (state, id) {
      state.id = id
    },
    updateName (state, name) {
      state.name = name
    },
    updateLang (state, lang) {
      state.lang = lang
    }
  }
}
